































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';

@Component
export default class AssemblyView extends Vue {
  public items: Common.Assembly[] = new Array(0);
  public params: Common.AssemblyQuery = new Common.AssemblyQuery();
  public importQuery = new Common.ImportQuery('セット品', 'Assembly');
  public exportQuery = new Common.ExportQuery('セット品', this.params);
  public tenantSettings: Common.TenantSettings = null;
  @Prop() public auditNo:string;
  @Prop() public id:number;

  public inputType:Common.InputTypes = Common.InputTypes.Order;
  public visibleTypes = Common.visibleTypes;  
  public voucherTypes = Common.voucherTypes;    
  public sortOptions: any = [
    { value: 'State', text:'状態' },
    { value: 'name', text: 'セット商品名称' },
    { value: 'commodity', text: '商品' },
    { value: 'initialSavedOn', text: '初回保存日' },
    { value: 'lastUpdatedOn', text: '最終更新日' },
  ];

  //一覧項目可変プロパティ
  public listCaptions = new Array();
  public listWidths = new Array();
  public listSlots = new Array();
  public listGridConfig:Common.GridConfiguration =
    new Common.GridConfiguration([],0, 'grid');

  public disabled(item : Common.Assembly) {
    return item == null || item.state != Common.MasterBaseStatus.Posted;
  }

  public created() {
    this.tenantSettings = this.$api.tenantSettings;

    // 予備項目表示の可変対応
    this.listGridConfig.setGridItems(
      new Common.GridItemConfiguration('状態', 100),
      new Common.GridItemConfiguration('ワークフロー', 180),      
      new Common.GridItemConfiguration('ID', 100),
      new Common.GridItemConfiguration('セット商品名称', 150),
      // new Common.GridItemConfiguration('商品コード', 150),      
      new Common.GridItemConfiguration('商品', 150),
      new Common.GridItemConfiguration('SKU', 150),
    );
    this.listGridConfig.setGridItems(...this.tenantSettings.GetGridItems(true,false,true,false,false));
    this.listGridConfig.setGridItems(
      new Common.GridItemConfiguration('初回保存日', 150),
      new Common.GridItemConfiguration('初回保存者', 150),
      new Common.GridItemConfiguration('最終更新日', 150),
      new Common.GridItemConfiguration('最終更新者', 150),
    );
    this.listCaptions =this.listGridConfig.gridCaptions;
    this.listWidths = this.listGridConfig.gridWidths;
    this.listSlots = this.listGridConfig.gridSlots;

    // 検索条件を設定する
    if(this.auditNo) {
      this.params.auditNo = this.auditNo;
      this.params.state = null;
    }

    if (this.id){
      this.params.id = this.id;
    }
    if(!this.auditNo && !this.id){
      this.params.holder = this.$api.license.countOnlyOwned ? this.$api.auth.userId : "";
		}
  }
  
  public async onCreate(obj: Common.Assembly) {
    const workflows = this.$api.formatter.getOptions('workflow_masterBase');
    if (workflows.length > 0) obj.workflowId = workflows[0].value;
    return Promise.resolve(obj);
  }

  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
  }

  public workflowRequired(item: Common.Assembly):boolean {
    if(item.state != Common.MasterBaseStatus.NotPosted) return false;
    var workflows = this.$api.formatter.getOptions('workflow_masterBase');
    return workflows.length > 0;
  }

  public isEditable(item: Common.Assembly):boolean {
    return item.state == Common.MasterBaseStatus.NotPosted;
  }
  public isEditableEditing(item: Common.Assembly):boolean {
    return item.state == Common.MasterBaseStatus.NotPosted || item.state == Common.MasterBaseStatus.Editing;
  }

  disableShowComponent:boolean = false;
  public onSelectedMain(index: number, selected: Common.Assembly) {
    this.disableShowComponent = selected.state != Common.MasterBaseStatus.Posted;
    //変更履歴のロードなどあると若干タイムラグが発生する
    // var query = new Common.AssemblyChildItemQuery(selected);
    // this.$api.execute(query).then(res => {
    //   var result = res as Common.AssemblyChildItemResult;  
    //   this.disableShowComponent = result.hasComponentItems == false;
    // });
  }

  //明細表示ボタンクリック時に画面遷移
  public showChildItems(item: Common.Assembly)
  {
      this.$router.push(String.format('/master/Component?assemblyId={0}', item.id));         
  }  
}
